const cards = [
  {
    title: '热门电影',
    desc: '最新院线大片、经典高分电影一网打尽，高清画质畅快观影',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20lighting%20and%20film%20grain%20texture%2C%20warm%20theater%20atmosphere%2C%20professional%20cinematography%20style%2C%20simple%20dark%20red%20background%2C%20elegant%20composition%2C%20movie%20poster%20aesthetic&width=800&height=600&seq=card-01&orientation=landscape',
    icon: 'ri-movie-2-line',
  },
  {
    title: '电视剧专区',
    desc: '热播国产剧、韩剧、美剧全集收录，追剧不等待一秒更新',
    img: 'https://readdy.ai/api/search-image?query=Television%20drama%20series%20visual%20with%20warm%20living%20room%20cinematic%20lighting%2C%20cozy%20home%20theater%20ambiance%2C%20soft%20golden%20glow%2C%20simple%20warm%20neutral%20background%2C%20elegant%20series%20binge%20watching%20aesthetic&width=800&height=600&seq=card-02&orientation=landscape',
    icon: 'ri-tv-2-line',
  },
  {
    title: '综艺娱乐',
    desc: '热门综艺、搞笑节目、真人秀精彩不断，轻松解压好选择',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20vibe%20with%20colorful%20stage%20lighting%2C%20cheerful%20bright%20atmosphere%2C%20warm%20festive%20background%2C%20simple%20and%20clean%20composition%2C%20show%20production%20aesthetic&width=800&height=600&seq=card-03&orientation=landscape',
    icon: 'ri-emotion-laugh-line',
  },
  {
    title: '动漫番剧',
    desc: '日漫、国漫、剧场版动漫高清合集，二次元爱好者宝藏站',
    img: 'https://readdy.ai/api/search-image?query=Anime%20animation%20style%20visual%20with%20vibrant%20warm%20colors%2C%20illustrative%20cinematic%20composition%2C%20soft%20gradient%20background%20with%20red%20and%20orange%20tones%2C%20clean%20artistic%20aesthetic%2C%20modern%20anime%20poster%20style&width=800&height=600&seq=card-04&orientation=landscape',
    icon: 'ri-ghost-line',
  },
  {
    title: '纪录片库',
    desc: 'BBC、央视等精品纪录片，自然、历史、科技全覆盖',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20visual%20with%20nature%20and%20science%20elements%2C%20warm%20earthy%20tones%2C%20professional%20cinematic%20photography%2C%20clean%20simple%20background%2C%20educational%20and%20elegant%20composition&width=800&height=600&seq=card-05&orientation=landscape',
    icon: 'ri-earth-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">影视分类</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">无论喜欢哪种类型，小辣椒影院都为你准备好了高清流畅的观影体验</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5 md:gap-6">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#carousel"
              className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className={`${card.icon} text-background-50 text-sm`}></i>
                  </div>
                  <span className="text-background-50 font-medium text-sm whitespace-nowrap">{card.title}</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}